import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
     },
  validationLabelError: {
    color: PALETTE.errorColor,
  },
  validationLabelSuccess: {
    paddingLeft:5,
    color:PALETTE.secondaryActive,
    marginBottom: 5,
  },
  textLabel:{
    color:PALETTE.secondaryActive , 
    marginBottom: 7,
    paddingLeft:20
  }
});
